// extracted by mini-css-extract-plugin
export default {"Overview":"Overview_Overview__Z0urs","Overview__banner":"Overview_Overview__banner__P-ZCi"};